import {useSearchCardUnification} from "../../hooks/useSearchCardUnification";

import LegacyProjectCard from "./LegacyProjectCard";
import type {ProjectHit} from "./ProjectHit";
import UnifiedProjectCard from "./UnifiedProjectCard";

export type {ProjectHit} from "./ProjectHit";

/**
 * A search-result project card, gated by the `searchCardUnification` control
 * of the `profile-listing-virtualized` feature flag: the unified shared card
 * (@buildwithflux/project-cards) when enabled, the legacy search-only card
 * otherwise. SSR and the first client render always use the legacy card; the
 * flag is evaluated client-side after auth resolves.
 */
export default function ProjectCard({project}: {project: ProjectHit}) {
    const unified = useSearchCardUnification();
    return unified ? <UnifiedProjectCard project={project} /> : <LegacyProjectCard project={project} />;
}
